export const SIDEBAR = '@sidebar/SIDEBAR'
